// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AccountImage extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK account */
  accountId!: string;
  /** Binary */
  data!: any;
  /** String(250) */
  description?: string;
  /** String(200) */
  fileName!: string;
  /** Int16 */
  height?: number;
  /** Boolean */
  isThumbnail!: boolean;
  /** String(60) */
  mimeType!: string;
  /** String(60) */
  name!: string;
  /** Binary */
  rowVersion!: any;
  /** Int16 */
  width?: number;
  /** FK accountId */
  account!: Account;
}

